import { pledgeApi, type PostPledgePledgeCancelByTeamPayload, queryClient } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const usePledgeCancelQuery = () => {
	return useMutation({
		mutationFn: async ({ data, teamId }: { data: PostPledgePledgeCancelByTeamPayload; teamId: string }) => {
			return await (await pledgeApi).postPledgePledgeCancelByTeam(teamId, data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['pledge-teams'] });
			queryClient.invalidateQueries({ queryKey: ['user-pledge-activity-summary'] });
		}
	});
};
